import { createTenantClient } from './apiClient';

const api = createTenantClient(process.env.REACT_APP_BACKEND_URL);

export const analyzeMobileApp = async (formData) => {
  const response = await api.post('/api/litesabre/mobile/analyze', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const listMobileAnalyses = async (limit = 20, skip = 0) => {
  const response = await api.get(`/api/litesabre/mobile/analyses?limit=${limit}&skip=${skip}`);
  return response.data;
};

export const getMobileAnalysis = async (analysisId) => {
  const response = await api.get(`/api/litesabre/mobile/analyses/${analysisId}`);
  return response.data;
};

export const deleteMobileAnalysis = async (analysisId) => {
  const response = await api.delete(`/api/litesabre/mobile/analyses/${analysisId}`);
  return response.data;
};

export const downloadMobileReport = async (analysisId, format = 'pdf', appName = 'app') => {
  const response = await api.get(
    `/api/litesabre/mobile/analyses/${analysisId}/report?format=${format}`,
    { responseType: 'blob' }
  );
  const mimeMap = {
    pdf: 'application/pdf',
    html: 'text/html',
    json: 'application/json',
  };
  const blob = new Blob([response.data], { type: mimeMap[format] || 'application/octet-stream' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  const safeName = (appName || 'app').replace(/\s+/g, '_');
  a.download = `mobile_report_${safeName}_${analysisId.slice(0, 8)}.${format}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const getRiskColor = (level) => {
  switch (level) {
    case 'Critical': return 'text-red-600 bg-red-50 border-red-200';
    case 'High': return 'text-orange-600 bg-orange-50 border-orange-200';
    case 'Medium': return 'text-yellow-600 bg-yellow-50 border-yellow-200';
    case 'Low': return 'text-green-600 bg-green-50 border-green-200';
    default: return 'text-gray-600 bg-gray-50 border-gray-200';
  }
};

export const getSeverityColor = (severity) => {
  switch (severity) {
    case 'critical': return 'bg-red-100 text-red-800 border-red-200';
    case 'high': return 'bg-orange-100 text-orange-800 border-orange-200';
    case 'medium': return 'bg-yellow-100 text-yellow-800 border-yellow-200';
    case 'low': return 'bg-blue-100 text-blue-800 border-blue-200';
    default: return 'bg-gray-100 text-gray-800 border-gray-200';
  }
};
